/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Grid } from '../../../components/Grid';
import TruncatedText from '../../../components/TruncatedText';
import { Small } from '../../../components/Text';

interface Props {
  shareCard: any;
  shareCardColorModel: any;
}
const ShareCardCommentRow: React.FC<Props> = (props) => (
  props.shareCard.comment.hasComment() ? (
    <Grid justifyContent="space-between">
      <TruncatedText widthOffset="50px">
        <Small>
          {props.shareCard.comment.get()}
        </Small>
      </TruncatedText>
      <div style={{ color: props.shareCardColorModel.cssColor(1) }}>
        <Small>
        <FormattedMessage id="share.more.button.label" />
        </Small>
      </div>
    </Grid>
  ) : (
    <Small>
      <FormattedMessage id="share.addComment.button.label" />
    </Small>
  )
);

export default ShareCardCommentRow;
